<template lang="">
  <v-main>
    <v-container fluid>
      <SignupConfirm />
    </v-container>
  </v-main>
</template>

<script>
import SignupConfirm from '../organisms/SignupConfirm.vue'

export default {
  name: 'SignupConfirmPage',
  components: {
    SignupConfirm,
  },
}
</script>
